import React from 'react'
import Link from '../fm/lib/Link'

const LinkRenderer = ({field, value}) => {
        if(!value) return null
        return <div className={`field-${field.name}`}><Link className='field-link'
                to={value.path || ''}
                >{value.label || ''}</Link></div>
}

const MapRenderer = ({field, value}) => {
        if(!value) return null
        return <div className={`field-${field.name} embed-paper`}><div className='content'>
        	<iframe title='map' src={value} frameBorder="0" style={{border:0}} allowFullScreen='1'></iframe>
        </div></div>
}

const fieldRenderer = {
	link: LinkRenderer,
	map: MapRenderer
}
export {fieldRenderer}




// WEBPACK FOOTER //
// ./src/conf/fieldRenderer.js